var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrinter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_172_1175)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.99967 11.9997H2.66634C2.31272 11.9997 1.97358 11.8592 1.72353 11.6092C1.47348 11.3591 1.33301 11.02 1.33301 10.6663L1.33301 7.33301C1.33301 6.97939 1.47348 6.64025 1.72353 6.3902C1.97358 6.14015 2.31272 5.99967 2.66634 5.99967L13.333 5.99967C13.6866 5.99967 14.0258 6.14015 14.2758 6.3902C14.5259 6.64025 14.6663 6.97939 14.6663 7.33301V10.6663C14.6663 11.02 14.5259 11.3591 14.2758 11.6092C14.0258 11.8592 13.6866 11.9997 13.333 11.9997H11.9997M3.99967 5.99967L3.99967 1.99967C3.99967 1.82286 4.06991 1.65329 4.19494 1.52827C4.31996 1.40325 4.48953 1.33301 4.66634 1.33301L11.333 1.33301C11.5098 1.33301 11.6794 1.40325 11.8044 1.52827C11.9294 1.65329 11.9997 1.82286 11.9997 1.99967V5.99967M4.66634 9.33301L11.333 9.33301C11.7012 9.33301 11.9997 9.63148 11.9997 9.99967V13.9997C11.9997 14.3679 11.7012 14.6663 11.333 14.6663L4.66634 14.6663C4.29815 14.6663 3.99967 14.3679 3.99967 13.9997L3.99967 9.99967C3.99967 9.63148 4.29815 9.33301 4.66634 9.33301Z",
    stroke: "white",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_172_1175"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrinter);
export default __webpack_public_path__ + "static/media/Printer.22c52c8f2000666db8a6ea93428b1d7c.svg";
export { ForwardRef as ReactComponent };